import { AutocompleteOptionType } from '@occc/ui-design-system';
import { SegmentFragment } from '@occc/graphql';

export const mapRawSegmentResponseItemToAutocompleteOption = (
  segment: SegmentFragment,
): AutocompleteOptionType<SegmentFragment> => ({
  label: segment.name,
  description: segment.description,
  value: segment.uuid,
  _raw: segment,
});
